module.exports = " \r\n  <ul class=\"pagination pagination--desktop\">\r\n    <li class=\"pagination__item\" ng-repeat=\"page in $ctrl.pager.pages\" ng-class=\"{'active':$ctrl.pager.currentPage==page}\">\r\n      <a href=\"#\" ng-click=\"$ctrl.toPage(page)\" class=\"pagination__link\" ng-bind=\"page\"></a>\r\n    </li>\r\n   \r\n  </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/pagination/paginations.html
// module id = 73
// module chunks = 1